<!-- Main Container -->
<div
  class="container-fluid  "
  [ngClass]="{
    'overlay_filter1': isAdmin,
    'overlay_filter2': route === 'home',
    'overlay_filter': !isAdmin
  }"
>

  <!-- === Common Filter Controls Template === -->
  <ng-template #filterControls  >
    <!-- Location Autocomplete -->
    <div class="col border-end" [ngClass]="isAdmin ? 'location' : 'loc'">
      <div class="addProperty__dropdown location">
        <AutocompleteComponent
          (setAddress)="formatAddress($event)"
          adressType="geocode"
          [initialLocation]="selectedLocation"
          [labelClass]="'filter__dropdownLabel'"
          [showStar]="false"
          class="'filter-maps-irr filter-maps-irr-error'"
        ></AutocompleteComponent>
      </div>
    </div>

    <!-- Property Type Dropdown -->
    <div class="col border-end">
      <div class="addProperty__dropdown">
        <select class="addProperty__dropdownOptions propet-s custom-dropdown-arrow" [(ngModel)]="selectedPropertyType">
          <option [value]="null"> Property</option>
          <option *ngFor="let category of propertyList" [ngValue]="category?.name">{{ category.name }}</option>
        </select>
      </div>
    </div>

    <!-- Min Budget -->
    <div class="col border-end ">
      <div class="addProperty__dropdown">
        <select
          class="addProperty__dropdownOptions custom-dropdown-arrow"
          [(ngModel)]="selectedMinBudget"
          (change)="onMinBudgetChange($event)"
        >
          <option value="null"> Min Budget</option>
          <option *ngFor="let budget of minBudgetOptions" [value]="budget.value">{{ budget.label }}</option>
        </select>
      </div>
    </div>

    <!-- Max Budget -->
    <div class="col border-end" [ngClass]="{ max: !isAdmin }">
      <div class="addProperty__dropdown">
        <select
          class="addProperty__dropdownOptions custom-dropdown-arrow"
          [(ngModel)]="selectedMaxBudget"
          (change)="onMaxBudgetChange($event)"
        >
          <option value="null">Max Budget</option>
          <option *ngFor="let budget of maxBudgetOptions" [value]="budget.value">{{ budget.label }}</option>
        </select>
      </div>
    </div>

    <!-- Amenities -->
    <div class="col border-end">
      <div class="custom-dropdown addProperty__dropdown position-relative">
        <div
          class="addProperty__dropdownOptions"
          [ngClass]="{ amenities: isAdmin }"
          (click)="toggleDropdown()"
          style="cursor:pointer;"
        >
          <span *ngIf="selectedAmenities.length === 0" class="am">Amenities</span>
            <span *ngIf="selectedAmenities.length === 1"  class="text-truncate d-inline-block" style="max-width: 140px;">{{ selectedAmenities[0]?.name }}</span>
          <span *ngIf="selectedAmenities.length > 1"  class="text-truncate d-inline-block" style="max-width: 120px;">
            {{ selectedAmenities[0]?.name }} +{{ selectedAmenities.length - 1 }} more
          </span>
        </div>
        <div
          class="dropdown-menu show  mt-1"
          *ngIf="dropdownOpen"
          style="position: absolute; top: 100%; left: 0; z-index: 1050; max-height: 220px; overflow-y: auto;"
        >
          <div *ngFor="let amenity of amenitiesdata" class="dropdown-item propet-s">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="isSelected(amenity)"
                (change)="toggleSelection(amenity)"
                [id]="'amenity-' + amenity.id"
              />
                <label class="form-check-label text-truncate d-block" [for]="'amenity-' + amenity.id" >
                {{ amenity.name }}
                </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- === Search Button Template === -->
  <ng-template #searchButton>
    <div class="col-auto  search p-0" [ngClass]="{ serch: !isAdmin }">
      <app-common-button
        (click)="navigateToProperties()"
        [faIcon]="faSearch"
        buttonClass="smaiifilledbutton btn btn-primary w-100"
        buttonLabel="Search"
        class="search-button"
      ></app-common-button>
    </div>
  </ng-template>

  <!-- === Desktop View === -->
  <div class="row m-2 justify-content-between" *ngIf="route === 'home' && !isMobile && !isTab">
    <ng-container *ngTemplateOutlet="filterControls"></ng-container>
    <ng-container *ngTemplateOutlet="searchButton"></ng-container>
  </div>

  <!-- === Properties List View === -->
  <div class="row propertiesList p-2 w-100 mx-auto" *ngIf="route === 'properties-list'">
    <ng-container *ngTemplateOutlet="filterControls"></ng-container>
    <ng-container *ngTemplateOutlet="searchButton"></ng-container>
  </div>

<!-- === Tablet View === -->
<div class="row" *ngIf="isTab && route === 'home'">
  <div class="col" *ngTemplateOutlet="filterControls"></div>
  <div class="col-auto mt-4" *ngTemplateOutlet="searchButton"></div>
</div>


<!-- === Mobile View === -->
<div *ngIf="isMobile && route === 'home'">
  <div class="row g-2 align-items-center">
    <!-- Location Input -->
    <div class="col-8">
      <div class="addProperty__dropdown location w-100">
        <AutocompleteComponent
          (setAddress)="formatAddress($event)"
          adressType="geocode"
          [labelClass]="'filter__dropdownLabel'"
          [initialLocation]="selectedLocation"
          [showStar]="false"
          class="'filter-maps-irr filter-maps-irr-error'"
        ></AutocompleteComponent>
      </div>
    </div>

    <!-- Search Button -->
    <div class="col-4 text-sm-center">
      <ng-container *ngTemplateOutlet="searchButton"></ng-container>
    </div>
  </div>
</div>


</div>

<!-- === Sleek Saved Properties Toggle === -->
<div
  *ngIf="checkLoginStatus && !isAdmin && !isHomePage"
  class="m-2 saved-toggle-wrapper"
>
  <button
    class="saved-toggle-btn"
    [class.active]="!isFavouriteChecked"
    (click)="onToggleFavourite(false)"
  >
    All
  </button>
  <button
    class="saved-toggle-btn"
    [class.active]="isFavouriteChecked"
    (click)="onToggleFavourite(true)"
  >
    <fa-icon [icon]="faHeart"></fa-icon> Saved
  </button>
</div>





